<template>
  <v-container>
    <v-row>
      <v-col
        cols="12"
        md="3"
      >
        <validated-text-field
          v-model="organization.name"
          field-name="name"
          rules="required"
          type="text"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <validated-text-field
          v-model="organization.short_name"
          field-name="short_name"
          rules="required"
          type="text"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <data-selector
          v-model="organization.contact_id"
          field-name="contact_id"
          label="contact_id"
          source-type="users-email"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <airport-selector
          v-model="organization.base_airport_id"
          field-name="base_airport"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <validated-text-field
          v-model="organization.address_hq"
          field-name="address_hq"
          rules="required"
          type="text"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <validated-text-field
          v-model="organization.address_site"
          field-name="address_site"
          rules=""
          type="text"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <validated-text-field
          v-model="organization.company_id"
          field-name="company_id"
          rules=""
          type="text"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <validated-text-field
          v-model="organization.vat_number"
          field-name="vat_number"
          rules=""
          type="text"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="3"
      >
        <validated-text-field
          v-model="organization.bank_name"
          field-name="bank_name"
          rules=""
          type="text"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <validated-text-field
          v-model="organization.bank_account_number"
          field-name="bank_account_number"
          rules=""
          type="text"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <data-selector
          v-model="organization.currency_id"
          field-name="currency_id"
          label="currency_id"
          source-type="currencies"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <data-selector
          v-model="organization.country"
          field-name="country"
          label="country"
          source-type="airportCountries"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <validated-text-field
          v-model="organization.bank_iban"
          field-name="bank_iban"
          rules=""
          type="text"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <validated-text-field
          v-model="organization.bank_swift"
          field-name="bank_swift"
          rules=""
          type="text"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="3"
      >
        <date-field
          v-model="organization.transaction_start"
          autofocus
          field-name="transaction_start"
          rules="required"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <validated-text-field
          v-model="organization.balance_min"
          field-name="balance_min"
          rules="required|numeric"
          type="numeric"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <validated-text-field
          v-model="organization.plane_limit"
          field-name="plane_limit"
          :disabled="!profile.has_role.supervisor"
          rules=""
          type="text"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <data-selector
          v-if="organization.package"
          v-model="organization.package.sys_product_id"
          field-name="subsription_package"
          disabled
          label="subsription_package"
          source-type="packages"
          rules="required"
        />
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col
        cols="12"
        md="6"
        align-self="center"
      >
        <app-card class="mt-4 text-center" justify="center">
          <v-card-title class="justify-center">
            <h6 class="text-h6 mb-2 text--secondary">
              {{ $t('fields.logo') }}
            </h6>
          </v-card-title>
          <v-card-text class="d-flex flex-column justify-space-between align-center">
            <v-img
              v-if="organization.avatar"
              max-height="150px"
              max-width="150px"
              :lazy-src="'data:image/jpeg;base64,' + organization.avatar.thumbnail"
              :src="dataUrl"
            />
          </v-card-text>
          <v-card-actions class="justify-center">
            <upload-files
              filter="avatar"
              source-type="avatar"
              class="mt-2"
              @success="uploaded"
            />
          </v-card-actions>
        </app-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { get } from 'vuex-pathify'

  export default {
    name: 'EditOrganization',
    props: {
      organization: Object,
    },
    computed: {
      profile: get('auth/profile'),
      dataUrl () {
        return process.env.VUE_APP_API_URL + '/api/storage/avatar/' + this.organization.avatar_id
      },
    },
    methods: {
      uploaded (response) {
        this.organization.avatar_id = response.id
        console.log(response.id)
      },
    },
  }
</script>
